<template>
  <div class="photos-browse" style="margin-top: 8px">
    <div class="row">
      <div class="col-sm-6">
        <span v-if="selectMode === true">
          <span v-if="selectedImages.length > 0">
            <button v-if="selectMode === true && selectedImages.length > 0" v-on:click="showSelectChildren = true"
                    class="btn btn-info me-1">Delen</button>
            <button v-if="selectMode === true && selectedImages.length > 0" v-on:click="deletePhotos(selectedImages)"
                    class="btn btn-danger me-1">Verwijderen</button>
          </span>
          <span v-else>
            <button class="btn btn-info me-1" disabled>Delen</button>
            <button class="btn btn-danger me-1" disabled>Verwijderen</button>
          </span>
          <button v-on:click="selectMode = false; selectedImages = []" class="btn btn-secondary me-1">Annuleren</button>
        </span>
        <span v-if="selectMode === false">
          <button v-on:click="selectMode = true; selectedImages = []" class="btn btn-info me-1">Selecteren</button>
        </span>
        <span>
          <button class="btn btn-info" @click="filterUnshared">
            <span v-if="filterUnsharedState === true">Toon alle</span>
            <span v-else>Toon niet gedeeld</span>
          </button>
        </span>
      </div>
      <div class="col-sm-6 text-end">
        <date-range-select v-show="selectMode === false" type="day"
                           @changeDateRange="setDateRange($event.dateStart, $event.dateEnd)"></date-range-select>
      </div>
    </div>
    <br>
    <div v-if="imagesFiltered">
      <div v-if="imagesFiltered.length > 0" class="row">
        <div
            v-for="image in imagesFiltered"
            :key="image.id"
            :class="['card mb-1 p-0', getSelectedClass(image)]"
            style="width: 225px; margin-right: 5px;"
        >
            <div
                v-if="image.shared && image.shared.length > 0"
                class="shared d-flex justify-content-center align-items-center"
                style="background-color: #39b3d7; border: 1px solid white;"
            >
                <icon name="shared" :fontSize="'1rem'" style="color: white;"></icon>
            </div>
          <img v-on:click="handlePhotoClick(image)" class="fit-image" :src="image.link_viewer + '?thumbnail=1&token=' + $store.getters.imageToken" height="150">
          <div class="card-footer bg-white m-0 p-0 pt-2 ps-1">
            <div class="d-flex" style="height: 45px" v-on:click="showShared('open', image)">
              <div v-for="(shared, index) in image.shared.slice(0, image.shared.length > 5 ? 4 : 5)" v-bind:key="index" class="me-1">
                <child-thumbnail :type="'show-simple'" :key="shared" :child="getChild(shared)"
                                 :height="'40px'"></child-thumbnail>
              </div>
              <div v-if="image.shared.length > 5">
                <div class="group-thumbnail"
                     style="background-color: #ffffff; height: 40px; width: 40px; border: 1px solid #dedee7;">
                  <span style="color: black; font-size: 14px;"> +{{ image.shared.length - 4 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        Geen foto's
      </div>
    </div>
    <modal v-if="selectMode === true && showSelectChildren === true">
      <template v-slot:header>
        <h3 class="modal-title">
          Delen
        </h3>
      </template>
      <template v-slot:body>
        <div>
          <child-select :showAllowPhoto="true" @onSelect="setChildren($event)"></child-select>
          <textarea-plus-two v-model="message" placeholder="Bericht" :maxlength="255"></textarea-plus-two>
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <button type="button" class="btn btn-outline-info me-1" v-on:click="showSelectChildren = false">Annuleren</button>
          <button v-if="selectedChildren.length > 0" v-on:click="sharePhotos(selectedImages, selectedChildren)"
                  class="btn btn-info">Opslaan
          </button>
        </div>
      </template>
    </modal>
    <modal v-if="showSharedChildren">
      <template v-slot:header>
        <h3 class="modal-title">
          Foto gedeeld met
        </h3>
      </template>
      <template v-slot:body>
        <div>
          <div class="row">
            <div v-for="(shared, index) in image.shared" v-bind:key="index" class="col-6">
              <div class="d-flex">
                <child-thumbnail class="m-1" :type="'show-simple'" :key="shared" :child="getChild(shared)"
                                 :height="'50px'"></child-thumbnail>
                <div class="d-flex w-100 flex-column justify-content-center">
                  <div class="d-flex flex-row">
                  <div class="flex-fill">{{ getChild(shared).full_name }}</div>
                  <div @click="unShare(image.id, shared)" class="btn btn-outline-danger">Ontkoppel</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div>
          <button type="button" class="btn btn-outline-info" v-on:click="showShared('close')">sluiten</button>
        </div>
      </template>
    </modal>
    <div v-if="showFull">
      <div class="full" v-on:click="toggleShowFull">
        <div class="full-message">{{ image.message }}</div>
        <div class="d-flex justify-content-center">
          <img :src="image.link_viewer+ '?token=' + $store.getters.imageToken">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateRangeSelect from '@/components/Date-Range-Select'
import Modal from '@/components/Modal'
import Icon from '@/components/Icon'
import ChildSelect from '@/components/Child-Select'
import TextareaPlusTwo from '@/components/Textarea-Plus-Two'
import ChildThumbnail from '@/components/Child-Thumbnail'

export default {
  name: 'photos-browse',
  components: {
    DateRangeSelect,
    Modal,
    Icon,
    ChildSelect,
    TextareaPlusTwo,
    ChildThumbnail,
  },
  data() {
    return {
      showSharedChildren: false,
      showSelectChildren: false,
      selectMode: false,
      showFull: false,
      photos: null,
      images: [],
      image: null,
      selectedImages: [],
      selectedChildren: [],
      message: '',
      dateStart: null,
      dateEnd: null,
      filterUnsharedState: false,
    }
  },
  computed: {
    selectedGroupsQueryString() {
      return this.$store.getters.selectedGroupsQueryString
    },
    imagesFiltered() {
      if (this.filterUnsharedState === true) {
        return this.images.filter((image) => {
          return image.shared.length === 0
        })
      }
      return this.images
    }
  },
  methods: {
    setChildren(children) {
      this.selectedChildren = children
    },
    setDateRange(dateStart, dateEnd) {
      this.dateStart = dateStart
      this.dateEnd = dateEnd
      this.$emit('setDate', dateStart)
      this.getPhotos(dateStart, dateEnd)
    },
    getPhotos(dateStart, dateEnd) {
      this.photos = null
      this.images = []
      this.$request.get('/photos?id_group=' + this.selectedGroupsQueryString + '&date=' + dateStart + '&up_to_date=' + dateEnd)
          .then((response) => {
            if (response.data) {
              this.images = response.data
            }
          })
    },
    handlePhotoClick(image) {
      if (this.selectMode === true) {
        this.selectPhoto(image)
      } else if (this.selectMode === false) {
        this.toggleShowFull(image)
      }
    },
    selectPhoto(image) {
      if (this.getSelectedClass(image)) {
        this.selectedImages = this.selectedImages.filter(function (e) {
          return e.id !== image.id
        })
      } else {
        this.selectedImages.push({
          id: image.id,
          shared: image.shared
        })
      }
    },
    getSelectedClass(image) {
      var selectedClass = ''
      for (var i = 0; i < this.selectedImages.length; i++) {
        if (this.selectedImages[i].id === image.id) {
          selectedClass = 'selected'
        }
      }
      return selectedClass
    },
    toggleShowFull: function (image) {
      if (this.showFull === false) {
        this.image = image
        this.showFull = true
      } else if (this.showFull === true) {
        this.image = null
        this.showFull = false
      }
      return false
    },
    deletePhotos(images) {
      if (confirm('Weet je zeker dat je deze foto\'s wilt verwijderen?') !== true) {
        return
      }
      this.selectedImages = []
      this.selectMode = false
      images = images || []
      for (var i = 0; i < images.length; i++) {
        this.$request.delete('/photos/' + images[i].id)
            .then(() => {
              this.setDateRange(this.dateStart, this.dateEnd)
            })
      }
    },
    sharePhotos(images, children) {
      images = images || []
      children = children || []
      if (images.length < 1) {
        return
      }
      if (children.length < 1) {
        return
      }
      this.selectedImages = []
      this.selectedChildren = []
      this.showSelectChildren = false
      this.selectMode = false
      for (var i = 0; i < images.length; i++) {
        var childrenString = ''
        for (var j = 0; j < children.length; j++) {
          childrenString += children[j].id + ','
        }
        if (typeof images[i].shared !== 'undefined' && images[i].shared.length > 0) {
          for (var k = 0; k < images[i].shared.length; k++) {
            childrenString += images[i].shared[k] + ','
          }
        }
        var data = {
          idPhoto: images[i].id,
          children: childrenString,
          message: this.message
        }
        this.$request.post('/deprecated/share-photo/' + images[i].id, data)
            .then(() => {
              this.setDateRange(this.dateStart, this.dateEnd)
              this.message = ''
            })
      }
    },
    showShared(type, image = null) {
      if (type === 'open') {
        this.showSharedChildren = true
        this.image = image
      } else {
        this.showSharedChildren = false
        this.image = image
      }
    },
    unShare(idPhoto, idChild) {
      this.$request.delete('/photos/' + idPhoto + '/share/' + idChild)
          .then(() => {
            this.showShared('close');
            this.setDateRange(this.dateStart, this.dateEnd)
          })
    },
    filterUnshared() {
      this.filterUnsharedState = !this.filterUnsharedState;
    }
  }
}
</script>

<style scoped>
.full {
  z-index: 1000;
  background: rgba(0, 0, 0, 0.99);
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.full img {
  margin-top: -50%;
  z-index: 1001;
  width: auto;
  max-width: 90%;
  height: auto;
  max-height: 90%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.full-message {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  color: #ffffff;
}


.selected {
  border: 5px solid #5bc0de;
}

.image-wrapper {
  position: relative;
}

.image {
  display: inline-block;
  position: relative;
}

.image-message {
  max-width: 275px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.shared {
    position: absolute;
    top: 110px;
    right: 10px;
    width: 30px;
    height: 30px;
    z-index: 5;
    border-radius: 50%;
}

.fit-image {
  object-fit: contain;
  background: #000000;
}

</style>
